import React from 'react';
import { Box, Typography, RadioGroup, FormControlLabel, Radio, TextField, useTheme } from '@mui/material';

interface GlobalOptionsProps {
  logDir: string;
  setLogDir: (value: string) => void;
  placeholder: string;
  operationType: string;
  setOperationType: (v: string) => void;
}

const GlobalOptions: React.FC<GlobalOptionsProps> = ({ logDir, setLogDir, placeholder, operationType, setOperationType }) => {
  const theme = useTheme();

  return (
    <Box sx={{ maxWidth: 1200, alignItems: 'flex-start' }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: theme.palette.primary.main, fontSize: 18 }}>
        Operation Type:
      </Typography>
      <RadioGroup
        value={operationType}
        onChange={e => setOperationType(e.target.value)}
        sx={{ mb: 4 }}
      >
        <Box
          sx={{
            borderRadius: 2,
            transition: 'background 0.2s, box-shadow 0.2s',
            '&:hover': {
              background: theme.palette.mode === 'light' ? '#f0f4fa' : '#23272f',
              boxShadow: '0 0 0 8px rgba(0, 188, 212, 0.16)',
              '& .label-text': {
                color: theme.palette.primary.main,
              },
            },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <FormControlLabel
            value="upgrade"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>Upgrade Database</span>
              </Box>
            }
            sx={{ flex: 1 }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: 2,
            transition: 'background 0.2s, box-shadow 0.2s',
            '&:hover': {
              background: theme.palette.mode === 'light' ? '#f0f4fa' : '#23272f',
              boxShadow: '0 0 0 8px rgba(0, 188, 212, 0.16)',
              '& .label-text': {
                color: theme.palette.primary.main,
              },
            },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <FormControlLabel
            value="patch"
            control={<Radio />}
            label={<Box className="label-text" sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.primary, transition: 'color 0.2s' }}><span>Patch Database</span></Box>}
            sx={{ flex: 1 }}
          />
        </Box>
      </RadioGroup>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        Global Log Directory:
      </Typography>
      <TextField
        fullWidth
        size="small"
        value={logDir}
        onChange={e => setLogDir(e.target.value)}
        onFocus={() => logDir === placeholder && setLogDir('')}
        variant="outlined"
        placeholder={placeholder}
        sx={{
          width: '100%',
          fontSize: 13,
          background: 'background.paper',
          '& .MuiInputBase-input::placeholder': { color: '#b0b0b0', opacity: 1 },
          '& .MuiInputBase-input': {
            fontSize: 13,
            color: theme.palette.text.primary,
          },
        }}
      />
    </Box>
  );
};

export default GlobalOptions;
